module.exports = __webpack_public_path__ + "media/images/phone-ab8acf4239e9f8beef3dc0542721185b.svg";